/// <amd-module name="VSS/Platform/RestClient/WebContributions" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as WebContributions from "../Contracts/WebContributions";

import { IWebContributionsRestClient } from "VSS/Platform/RestClient/WebContributions.Types";

export { IWebContributionsRestClient } from "VSS/Platform/RestClient/WebContributions.Types";

class WebContributionsRestClient extends RestClientBase implements IWebContributionsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets the contribution hierarchy for the given site and root contribution id(s).
     * 
     * @param query - Object containing the contribution ids and data provider context to use in the query
     * @param scopeName - Name of the scope to apply on returned data provider
     * @param scopeValue - Value of the scope to apply on returned data provider
     */
    public async queryContributedHierarchy(
        query: WebContributions.ContributedHierarchyQuery,
        scopeName?: string,
        scopeValue?: string
        ): Promise<WebContributions.ContributedHierarchy> {

        return this.beginRequest<WebContributions.ContributedHierarchy>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Contribution/HierarchyQuery/{scopeName}/{scopeValue}",
            routeValues: {
                scopeName: scopeName,
                scopeValue: scopeValue
            },
            body: query
        });
    }

}

export const WebContributionsClientName = "IWebContributionsRestClient";

export function getWebContributionsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWebContributionsRestClient {
    return pageContext.getRestClient<IWebContributionsRestClient>(WebContributionsClientName, options);
}

RestClients.add(WebContributionsClientName, { 
    factory: WebContributionsRestClient
});
